module.exports = __webpack_public_path__ + "img/Group 19.1a8a967f.svg";